'use client'

import type { Editor } from '@tiptap/react'

import type { ToolbarButtonDefinition } from './editor-toolbar.config'
import { EditorToolbarButton } from './editor-toolbar-button.atom'

export interface EditorToolbarButtonGroupProps {
  editor: Editor
  buttonList: ToolbarButtonDefinition[]
  isDisabled?: boolean
}

/**
 * Renders a group of toolbar buttons from a configuration array
 */
export const EditorToolbarButtonGroup = ({
  editor,
  buttonList,
  isDisabled = false,
}: EditorToolbarButtonGroupProps) => (
  <>
    {buttonList.map((button) => (
      <EditorToolbarButton
        key={button.id}
        label={button.label}
        shortcut={button.shortcut}
        isActive={button.isActive?.(editor)}
        onClick={() => button.action(editor)}
        disabled={isDisabled || (button.canExecute ? !button.canExecute(editor) : false)}
      >
        <button.icon className="size-4" />
      </EditorToolbarButton>
    ))}
  </>
)

EditorToolbarButtonGroup.displayName = 'EditorToolbarButtonGroup'
